import { render, staticRenderFns } from "./entriesIndex.vue?vue&type=template&id=bc3616e2"
import script from "./entriesIndex.vue?vue&type=script&lang=js"
export * from "./entriesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports